import EnvironmentSwitch from './EnvironmentSwitch';

export default EnvironmentSwitch;
